import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ImagePreview } from '@app/entities/images/interfaces/image-preview';
import { GalleryItemComponent } from '../gallery-item/gallery-item.component';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GalleryItemComponent],
})
export class GalleryComponent implements OnInit {
  @Input({ required: true }) galleryItems!: ImagePreview[];
  @Input() columns: number = 4;

  isGalleryRootPage = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    // Получаем текущий путь без query-параметров
    const currentUrl = this.router.url.split('?')[0];
    this.isGalleryRootPage = currentUrl === '/gallery';
  }

  trackIndex(index: number): number {
    return index;
  }
}
